<template>
    <div class="container">
        <div class="searchFlex">
            <!-- 搜索框 -->
            <el-form size="mini" ref="searchform" :model="searchForm" label-width="75px" :inline="true" class="demo-form-inline">
                <el-form-item label="开始日期">
                    <el-date-picker class="width_215" size="small" clearable v-model="searchForm.startTime" type="date" value-format="yyyy-MM-dd"
                        placeholder="选择送货开始时间" :picker-options="pickerStart">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="提单号">
                    <el-input size="small" clearable v-model.trim="searchForm.mblNo" placeholder="请输入提单号"
                        style="width: 100%;"></el-input>
                </el-form-item>
                <el-form-item label="车牌号">
                    <el-select  size="small" filterable clearable v-model.trim="searchForm.truckNo"
                        placeholder="请选择车牌号">
                        <el-option v-for="item in truckManList" :key="item.id" :label="item.vehicleNum"
                            :value="item.vehicleNum">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="司机">
                    <el-select size="small" filterable clearable v-model.trim="searchForm.truckMan"
                        placeholder="请选择司机">
                        <el-option v-for="item in truckManList" :key="item.id" :label="item.driver"
                            :value="item.driver">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="客户名称">
                    <el-select size="small" filterable clearable v-model="searchForm.customerName"
                        placeholder="请选择客户">
                        <el-option v-for="item in customerNameList" :key="item.id" :label="item.value"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="结束日期">
                    <el-date-picker class="width_215" size="small" clearable v-model="searchForm.endTime" type="date" value-format="yyyy-MM-dd"
                        placeholder="选择送货结束时间" :picker-options="pickerEnd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="起始地">
                    <el-select size="small" filterable clearable v-model="searchForm.startPort"
                        placeholder="请选择起始港">
                        <el-option v-for="item in portList" :key="item.id" :label="item.value"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="目的地">
                    <el-select size="small" filterable clearable v-model="searchForm.endPort"
                        placeholder="请选择目的港">
                        <el-option v-for="item in portList" :key="item.id" :label="item.value"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="任务类型">
                    <el-select  size="small" filterable clearable v-model="searchForm.taskType"
                        placeholder="请选择任务类型">
                        <el-option v-for="item in taskTypeList" :key="item.label" :label="item.label"
                            :value="item.label">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div class="toolbar">
                <div class="toolbar-left">
                    <el-button type="success" size="mini" @click="getData">查询</el-button>
                    <el-button type="warning" @click="exportExcel()" size="small">导出</el-button>
                </div>
                <!-- <el-button type="info" size="mini">删除任务</el-button> -->
                <!-- <vxe-toolbar ref="toolbarRef" custom> </vxe-toolbar> -->
            </div>
        </div>
        <div  style="margin-top: 0px;flex: 1;">
            <el-table :data="tableData" style="margin-top: 0px;" height="100%" size="mini" ref="report-table" :header-cell-style="{'text-align':'center'}">
                <el-table-column type="index" width="50"> </el-table-column>
                <el-table-column prop="requestTime" label="要求发货日期" width="95"> </el-table-column>
                <el-table-column prop="mblNo" label="提单号" width="110"> </el-table-column>
                <el-table-column prop="truckNo" label="车牌号" width="100"> </el-table-column>
                <el-table-column prop="truckMan" label="司机"> </el-table-column>
                <el-table-column prop="phoneNo" label="电话" width="100"> </el-table-column>
                <el-table-column prop="customerName" label="客户" width="200"> </el-table-column>
                <el-table-column prop="startPort" label="起始地"></el-table-column>
                <el-table-column prop="endPort" label="目的地"></el-table-column>
                <el-table-column prop="taskType" label="任务类型"></el-table-column>
                <el-table-column prop="salaryAmount" label="工资" width="60"></el-table-column>
                <el-table-column label="代垫费明细">
                    <el-table-column prop="fuelAmount" label="燃油费"></el-table-column>
                    <el-table-column prop="washFee" label="洗箱费"></el-table-column>
                    <el-table-column prop="qfFee" label="铅封费"></el-table-column>
                    <el-table-column prop="getFee" label="提箱费"></el-table-column>
                    <el-table-column prop="repairFee" label="修箱费"></el-table-column>
                    <el-table-column prop="liftFee" label="吊装费"></el-table-column>
                    <el-table-column prop="otherAmount" label="其他费用"></el-table-column>
                    <el-table-column prop="prepaymentTotal" label="代垫费合计" ></el-table-column>
                </el-table-column>
            </el-table>
        </div>

    </div>
</template>
<script>
import basicData from '@/config/basicData.js'
import ExcelJS from 'exceljs';
export default {
    name:"payroll",
    data() {
        return {
            searchForm: {  //    查询条件
                startTime: '',
                endTime: '',
                mblNo: '',
                truckNo: '',
                truckMan: '',
                customerName: '',
                startPort: '',
                endPort: '',
                taskType: '',
            },
            truckManList:[],
            customerNameList:[],
            portList:[],
            taskTypeList:basicData.taskType,
            tableData: [],
            pickerStart:{
                disabledDate: time => { 
                // 如果有 结束 日期 要选择结束之前的日期
                    if(this.searchForm.endTime){
                        return (
                        // 结束日期 小于 开始日期（开始日期不能选择 结束日期之后的日期）
                        new Date(this.searchForm.endTime).getTime() < time.getTime() 
                        );
                    }else{
                        // 如果没有结束日期 那么都可以选
                        return false
                    }
                }
            },
            // 结束时间限制范围
            pickerEnd:{
                disabledDate: time => {
                    // 如果有开始日期 
                    if(this.searchForm.beginTime){
                        return (((new Date(this.searchForm.beginTime).getTime())-3600*24*1000)>(time.getTime()));
                    }else{
                        // 如果没有开始日期 都可以选择
                        return false
                    }
                }
            },
        }
    },
    mounted() {
        this.getInfosByName()
        this.getcustomerList()
        this.getPort()
    },
    methods: {
        getData(){
            this.$api.getSalaryList( this.searchForm ).then(res =>{
                this.tableData = res
            })
        },
        getInfosByName(){
            this.$api.getInfosByName(  ).then(res =>{
                this.truckManList = res.tableData
            })
        },
        // 获取客户列表
        getcustomerList(){
            this.$api.getDicList( { value:'委托单位'} ).then(res =>{
                this.customerNameList = res
            })
        },  
        // 查询地址
        getPort() {
            this.$api.getDicList( { value:'陆运站点'} ).then(res =>{
                this.portList = res
            })
        },
        async exportExcel(){
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');
            const columns = [
                { header: '要求发货日期', key: 'requestTime', width: 20 },
                { header: '提单号', key: 'mblNo', width: 20 },
                { header: '车牌号', key: 'truckNo', width: 20 },
                { header: '司机', key: 'truckMan', width: 20 },
                { header: '电话', key: 'phoneNo', width: 20 },
                { header: '客户', key: 'customerName', width: 20 },
                { header: '起始地', key: 'startPort', width: 20 },
                { header: '目的地', key: 'endPort', width: 20 },
                { header: '任务类型', key: 'taskType', width: 20 },
                { header: '工资', key: 'salaryAmount', width: 20 },
                { header: '燃油费', key: 'fuelAmount', width: 20 },
                { header: '洗箱费', key: 'washFee', width: 20 },
                { header: '铅封费', key: 'qfFee', width: 20 },
                { header: '提箱费', key: 'getFee', width: 20 },
                { header: '修箱费', key: 'repairFee', width: 20 },
                { header: '吊装费', key: 'liftFee', width: 20 },
                { header: '其他费用', key: 'otherAmount', width: 20 },
                { header: '代垫费合计', key: 'prepaymentTotal', width: 20 },
            ];
              // 设置表头
            worksheet.columns = columns;
             // 添加数据行
            this.tableData.forEach(item => {
                worksheet.addRow(item);
            });

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${this.getFormattedDateTime()}`;
            link.click();
            window.URL.revokeObjectURL(url);
        },
        getFormattedDateTime() {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            return `工资表-${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
        },
    }
}
</script>
<style lang="css" scoped>
.width_215{
    width: 215px;
}
.el-form-item {
    margin-bottom: 5px;
}
.container {
    width: 100%;
    height: calc(100vh - 84px);
    background-color: rgb(255, 255, 255);
    display: flex;
    flex-direction: column;
}

.searchFlex {
    padding-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items:  flex-start;
    /* align-items: center; */
}

.toolbar {
    margin-right: 10px;
    /* width: 440px; */
    display: flex;
    justify-content: space-between;
}

.toolbar-left {
    display: flex;
    align-items: center;
    margin-right: 10px;
}
</style>